import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';
import SHA256 from 'crypto-js/sha256';
import HEX from 'crypto-js/enc-hex';

@Component({
  selector: 'gn-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnPasswordComponent),
    multi: true
  }]
})
@GnFormItem('password')
export class GnPasswordComponent implements ControlValueAccessor {

  private password: string;
  private hash: string;
  passwordVisible = false;

  @Input() placeholder = '';

  @Input() set value(value: string) {
    if (this.password !== value && this.hash !== value) {
      this.password = value;
      this.hash = (!this.password || this.password === '') ? null : HEX.stringify(SHA256(this.password));
      this.valueChange(this.hash);
    }
  }

  get value(): string {
    return this.password;
  }

  valueChange = (value: string) => {
  }

  constructor() {
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
